// extracted by mini-css-extract-plugin
module.exports = {"comp":"FooterTcA_comp__6Amiv"};